module.exports = __webpack_public_path__ + "static/img/备案图标.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/备案图标.png
// module id = X1JC
// module chunks = 1